import { InjectionToken } from '@angular/core';
import { UrlResolverPipeStrategy } from './url-resolver-pipe-strategy.interface';

export const URL_RESOLVER_STRATEGIES = new InjectionToken<UrlResolverPipeStrategy[]>('UrlResolverStrategies');
